// SPDX-FileCopyrightText: Copyright 2025 Dash0 Inc.

"use client";

import { ComponentPropsWithoutRef } from "react";


export function Code({ children, ...props }: ComponentPropsWithoutRef<"code">) {
	if (!children) return null;
	return <code className="text-[12px] border px-1 border-grey-850 rounded " {...props}>{children}</code>;
}
